/**
 * Environment Configuration
 * Centralizes all environment-specific settings
 */

export const ENV = {
  // Environment info
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_ENV: process.env.REACT_APP_ENV || 'development',

  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001',

  // Endpoints
  ENDPOINTS: {
    AUTH: process.env.REACT_APP_AUTH_ENDPOINT || '/api/auth',
    PROPERTIES: process.env.REACT_APP_PROPERTIES_ENDPOINT || '/api/properties',
    OCCUPANTS: process.env.REACT_APP_OCCUPANTS_ENDPOINT || '/api/occupants',
    PAYMENTS: process.env.REACT_APP_PAYMENTS_ENDPOINT || '/api/payments',
    TRANSACTIONS: process.env.REACT_APP_TRANSACTIONS_ENDPOINT || '/api/transactions',
  },

  // App Configuration
  APP_NAME: process.env.REACT_APP_APP_NAME || 'Rental Management System',
  VERSION: process.env.REACT_APP_VERSION || '1.0.0',

  // Feature Flags
  FEATURES: {
    ENABLE_SWAGGER_DOCS: process.env.REACT_APP_ENABLE_SWAGGER_DOCS === 'true',
    ENABLE_DEBUG_LOGS: process.env.REACT_APP_ENABLE_DEBUG_LOGS === 'true',
    MOCK_DATA_ENABLED: process.env.REACT_APP_MOCK_DATA_ENABLED === 'true',
    HOT_RELOAD: process.env.REACT_APP_HOT_RELOAD === 'true',
    SHOW_DEV_TOOLS: process.env.REACT_APP_SHOW_DEV_TOOLS === 'true',
  },

  // UI Configuration
  UI: {
    DEFAULT_CURRENCY: process.env.REACT_APP_DEFAULT_CURRENCY || 'AUD',
    DATE_FORMAT: process.env.REACT_APP_DATE_FORMAT || 'DD/MM/YYYY',
  },

  // Debug flag
  DEBUG: process.env.REACT_APP_DEBUG === 'true',
};

// Environment checks
export const isProduction = () => ENV.REACT_APP_ENV === 'production';
export const isDevelopment = () => ENV.REACT_APP_ENV === 'development' || ENV.REACT_APP_ENV === 'local';
export const isLocal = () => ENV.REACT_APP_ENV === 'local';

// API URL builder
export const buildApiUrl = (endpoint) => {
  const baseUrl = ENV.API_BASE_URL.replace(/\/$/, ''); // Remove trailing slash
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

// Debug logger
export const debugLog = (...args) => {
  if (ENV.DEBUG && ENV.FEATURES.ENABLE_DEBUG_LOGS) {
    console.log('[DEBUG]', ...args);
  }
};

// Environment info for debugging
export const getEnvironmentInfo = () => ({
  environment: ENV.REACT_APP_ENV,
  nodeEnv: ENV.NODE_ENV,
  apiBaseUrl: ENV.API_BASE_URL,
  appName: ENV.APP_NAME,
  version: ENV.VERSION,
  debug: ENV.DEBUG,
  features: ENV.FEATURES,
});

// Log environment info on load (only in development)
if (isDevelopment()) {
  console.log('🚀 Environment Configuration:', getEnvironmentInfo());
}
